'use client';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';

export const NavOffsetClient = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();
  return (
    <div
      // Note: we need to dynamically check the path, as the navigation is different on home page (video hero)
      className={classNames({
        navOffset: pathname != '/',
      })}
    >
      {children}
    </div>
  );
};
